import React, { ReactElement, useEffect } from 'react';
import './aktualitaOverviewItem.scss';
import { Heading, Text, Link } from 'idsk-react-components';
import DOMPurify from 'dompurify';
import { useImageSize } from 'react-image-size';
import Aktualita from '../../../../model/Aktualita';
import dateToString from '../../../../function/dateToString';
import defaultImage from '../../../../../assets/images/default-aktualita.svg';
import routes from '../../../../routing/routes';

interface Props {
  aktualita: Aktualita,
}

const AktualitaOverviewItem = ({
  aktualita,
}: Props): ReactElement => {
  const image = aktualita.img ? process.env.REACT_APP_MAGNOLIA_API_BASE_PATH + aktualita.img : defaultImage;
  const [dimensions] = useImageSize(image);

  useEffect(() => {
    makeHiddenClickableElementsInactive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aktualita?.id, aktualita?.text]);

  const makeHiddenClickableElementsInactive = (): void => {
    if (aktualita?.id && aktualita?.text) {
      const aktualitaTextElement = document.getElementById(`aktualita-text-${aktualita.id}`);
      if (aktualitaTextElement) {
        const aktualitaTextElementTop = aktualitaTextElement.getBoundingClientRect().top;
        const aktualitaTextElementHeight = aktualitaTextElement.getBoundingClientRect().height;
        const clickableElements = aktualitaTextElement.querySelectorAll('a,button');
        for (let i = 0; i < clickableElements.length; i += 1) {
          const clickableElement = clickableElements[i];
          const clickableElementTop = clickableElements[i].getBoundingClientRect().top;
          if (clickableElementTop > aktualitaTextElementTop + aktualitaTextElementHeight) {
            clickableElement.setAttribute('tabindex', '-1');
          }
        }
      }
    }
  };

  return (
    <div className="aktualita-overview-item">
      <Link
        className="link"
        to={routes.aktuality.detail.withParams(aktualita.id)}
      >
        {dimensions && (
          <img
            className={dimensions.width > dimensions.height ? 'landscape' : 'portrait'}
            src={image}
            alt={aktualita.title}
            tabIndex={-1}
          />
        )}

        <Heading className="overview-title" size="m">{aktualita.title}</Heading>
      </Link>
      <span
        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(aktualita?.text)}} // eslint-disable-line
        className="abbreviated"
        id={`aktualita-text-${aktualita.id}`}
      />
      <Text className="vypublikovane-date">{aktualita?.vypublikovane
        ? dateToString(new Date(aktualita.vypublikovane), false) : ''}
      </Text>
    </div>
  );
};

export default AktualitaOverviewItem;
